import { JdConst } from "./jd_define";

//牌局数据
export module JdTableData{
    //牌局中座位玩家信息数据
    export class SeatPlayerData{
        name:string;//玩家名字
        seat_id:number;//服务器座位ID
        player_id:number;//玩家id
        bet:number;//本轮玩家下注额
        cards:number[];//手牌
        card_type:number;//当前牌型
        card_point:number;//当前点数
        coin_balance:number;//玩家金币余额
        state:JdConst.SeatState;//座位状态
        account_balance:number;//账户余额
        reset(){
            this.card_type = 0;
            this.cards = [];
            this.bet = 0;
        }
    }

    //牌局数据
    export class BoardData{
        //庄家
        banker:number = -1;
        //赌池额
        pot:number;
        //游戏状态
        gameState:JdConst.GameState;
    }

    //公共数据
    export class commonData{
        maxBet:number;//本轮最大下注额
        min_join_coin:number;//最小加入
        max_join_coin:number;//最大加入
        game_BetMin:number;//最小下注
        sidePotIndex:number;//边池
        ackId:number;
        event:number;
        isNeedWaite:boolean;//是否需要等带发送ack
        progress:number;
        carryCoin:number;//携带金币
        minJoinPeople:number;
    }


    //选择自动操作的类型
    export enum AutoSetting{
        None = 0,
        Chek_Pass = 1,//自动过/弃牌
        Any_Call = 2,//跟任何注,
        Auto_Check = 3,//自动过牌
    }

    //自动选牌
    export class Setting{
        isMyRound:boolean;//是否是我方回合
        params:number//可允许的操作
        autoCheck?:AutoSetting = AutoSetting.None;//自动操作类型
        mount?:number;//跟的数量//当前跟的数量
        min?:number;
        chips:number;//玩家余额

        reset()
        {
            this.chips = 0;
            this.params = 0;
            this.mount = 0;
            this.isMyRound = false;
            this.autoCheck = AutoSetting.None;
        }
    }


}
